import { render, staticRenderFns } from "./Dashboard2Page.vue?vue&type=template&id=336a46b4&scoped=true&"
import script from "./Dashboard2Page.vue?vue&type=script&lang=js&"
export * from "./Dashboard2Page.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard2Page.vue?vue&type=style&index=0&id=336a46b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a46b4",
  null
  
)

component.options.__file = "Dashboard2Page.vue"
export default component.exports